import React, { Component } from "react";
import $ from "jquery";

class UpdateTimbraDocs extends Component {
  ChangeModelProperty = (value, key) => {
    const { UpdateTimbraDocModel, model } = this.props;
    model[key] = value;
    UpdateTimbraDocModel(model);
  };

  ChangeCardName = (value) => {
    const { UpdateTimbraDocModel, model } = this.props;
    if (value.length > 100) {
      model.CardName = value.substring(0, 100);
      model.U_FMB_AUX_CARDNAME = value;
    } else {
      model.CardName = value;
      model.U_FMB_AUX_CARDNAME = "";
    }
    UpdateTimbraDocModel(model);
  };

  render() {
    const {
      editMode,
      CloseUpdateDocModel,
      ChangeEditModeTimbraDocModal,
      AcceptEditMode,
    } = this.props;
    return (
      <div
        className="modal fade bd-example-modal-xl modal-open scroll"
        id="updateTimbraDocModal"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div
              className="modal-header text-white"
              style={{ backgroundColor: "#343a40", borderRadius: "0" }}
            >
              <h4 className="modal-title" id="modal-basic-title ">
                DATOS DE TIMBRADO{" "}
              </h4>
              <button
                type="button"
                className="close"
                onClick={() => CloseUpdateDocModel()}
                aria-label="Close"
              >
                <span className="text-white" aria-hidden="true">
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="contanier">
                <div className="row justify-content-around">
                  <div className="col-12">
                    <br />
                    <div>
                      <table
                        className="table response"
                        style={{ marginBottom: 0 }}
                      >
                        {!editMode && this.renderEditButton()}
                        {this.renderBody()}
                        <br />
                        <br />
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn botonCerrar text-white"
                onClick={() => CloseUpdateDocModel()}
              >
                Cerrar
              </button>

              {editMode && (
                <button
                  type="button"
                  className="btn botonCorrect"
                  onClick={() => AcceptEditMode()}
                >
                  Actualizar datos
                </button>
              )}
              {editMode && (
                <button
                  type="button"
                  className="btn botonCorrect"
                  onClick={() => ChangeEditModeTimbraDocModal()}
                >
                  Cancelar edición
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderEditButton = () => {
    const { ChangeEditModeTimbraDocModal } = this.props;
    return (
      <>
        <button
          type="button"
          style={{ backgroundColor: "transparent", color: "#000" }}
          className="btn btn-editar"
          // onClick={this.editMode}
          onClick={() => ChangeEditModeTimbraDocModal()}
        >
          <i className="fas fa-edit  fa-lg" />
          Editar
        </button>
      </>
    );
  };

  renderBody = () => {
    const { CFDI, RegimenFiscal, model, editMode } = this.props;
    const typeDoc = $("#selectDocTypeDocumentSearchPTD").val() ?? "--";
    return (
      <>
        <div className="row">
          {/*PRIMER COLUMNA SOCIOS DE NEGOCIO*/}
          <div className="col-12 col-md-6">
            {/* CARD NAME */}
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span
                  className="input-group-text font-weight-bold"
                  id="basic-addon1"
                >
                  NOMBRE:{" "}
                </span>
              </div>
              <input
                type="text"
                className="form-control"
                disabled={!editMode ?? false}
                value={model.U_FMB_AUX_CARDNAME || (model.CardName || "")}
                maxLength={200}
                onChange={(event) => this.ChangeCardName(event.target.value)}
              />
            </div>
            {/* FECHA */}
            {/* <div className="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text font-weight-bold" id="basic-addon1">FECHA: </span>
                            </div>
                            <input type="date" className="form-control"
                                disabled={!editMode ?? false}
                                value={model?.TimbraDate ?? ""}
                                maxLength={100}
                                onChange={(event) => this.ChangeModelProperty(event.target.value, 'TimbraDate')}
                            />
                        </div> */}
            {/* RFC */}
            {Number(typeDoc) !== 24 && (
              <>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text font-weight-bold"
                      id="basic-addon1"
                    >
                      RUT:{" "}
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    disabled={!editMode ?? false}
                    id="txtLicTradNum"
                    value={model?.LicTradNum ?? ""}
                    maxLength={32}
                    onChange={(event) =>
                      this.ChangeModelProperty(event.target.value, "LicTradNum")
                    }
                  />
                </div>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text font-weight-bold"
                      id="basic-addon1"
                    >
                      CÓDIGO POSTAL FACTURACION:{" "}
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    maxLength={5}
                    value={model?.ZipCode ?? ""}
                    disabled={!editMode ?? false}
                    onChange={(event) =>
                      this.ChangeModelProperty(event.target.value, "ZipCode")
                    }
                  />
                </div>
              </>
            )}

            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span
                  className="input-group-text font-weight-bold"
                  id="basic-addon1"
                >
                  REGIMEN FISCAL:{" "}
                </span>
              </div>
              <select
                id="selectUsoCFDI"
                className="form-control "
                value={model?.U_FMB_REGIMEN_FISCAL ?? ""}
                disabled={!editMode ?? false}
                onChange={(event) =>
                  this.ChangeModelProperty(
                    event.target.value,
                    "U_FMB_REGIMEN_FISCAL"
                  )
                }
              >
                <option value="">Seleccione un regimen fiscal</option>
                {RegimenFiscal &&
                  RegimenFiscal.length > 0 &&
                  RegimenFiscal.map((element) => {
                    return (
                      <option value={element?.FldValue}>
                        {element?.FldValue ? element?.FldValue + " - " : ""}
                        {element.Descr ? element.Descr : ""}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span
                  className="input-group-text font-weight-bold"
                  id="basic-addon1"
                >
                  USO DE CFDI:{" "}
                </span>
              </div>
              <select
                id="selectUsoCFDI"
                className="form-control "
                value={model?.U_FMB_USO_CFDI ?? ""}
                onChange={(event) =>
                  this.ChangeModelProperty(event.target.value, "U_FMB_USO_CFDI")
                }
                disabled={!editMode ?? false}
              >
                <option value="">Seleccione un uso de CFDI</option>
                <option value="CP01">CP01 - Pagos</option>
                {CFDI &&
                  CFDI.length > 0 &&
                  CFDI.map((element) => {
                    return (
                      <option value={element?.FldValue}>
                        {element?.FldValue ? element?.FldValue + " - " : ""}
                        {element.Descr ? element.Descr : ""}
                      </option>
                    );
                  })}
              </select>
            </div>

            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span
                  className="input-group-text font-weight-bold"
                  id="paymentMethod"
                >
                  MÉTODO DE PAGO:{" "}
                </span>
              </div>
              <select
                id="selectPaymentMethod"
                className="form-control "
                value={model?.U_FMB_METODO_PAGO ?? ""}
                onChange={(event) =>
                  this.ChangeModelProperty(
                    event.target.value,
                    "U_FMB_METODO_PAGO"
                  )
                }
                disabled={!editMode ?? false}
              >
                <option value="">Seleccione una forma de pago</option>
                <option value="PUE">PUE - Pago en una exhibición</option>
                <option value="PPD">
                  PPD - Pago en parcialidades o diferido
                </option>
              </select>
            </div>

            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span
                  className="input-group-text font-weight-bold"
                  id="basic-addon1"
                >
                  FORMA DE PAGO:{" "}
                </span>
              </div>
              <select
                id="selectUsoCFDI"
                className="form-control "
                value={model?.U_FMB_FORMA_PAGO ?? ""}
                onChange={(event) =>
                  this.ChangeModelProperty(
                    event.target.value,
                    "U_FMB_FORMA_PAGO"
                  )
                }
                disabled={!editMode ?? false}
              >
                <option value="">Seleccione una forma de pago</option>
                <option value="01">01 - Efectivo</option>
                <option value="02">02 - Cheque nominativo</option>
                <option value="03">
                  03 - Transferencia electrónica de fondos
                </option>
                <option value="04">04 - Tarjeta de crédito</option>
                <option value="05">05 - Monedero electrónico</option>
                <option value="06">06 - Dinero electrónico</option>
                <option value="08">08 - Vales de despensa</option>
                <option value="12">12 - Dación en pago</option>
                <option value="13">13 - Pago por subrogación</option>
                <option value="14">14 - Pago por consignación</option>
                <option value="15">15 - Condonación</option>
                <option value="17">17 - Compensación</option>
                <option value="23">23 - Novación</option>
                <option value="24">24 - Confusión</option>
                <option value="25">25 - Remisión de deuda</option>
                <option value="26">26 - Prescripción o caducidad</option>
                <option value="27">27 - A satisfacción del acreedor</option>
                <option value="28">28 - Tarjeta de débito</option>
                <option value="29">29 - Tarjeta de servicios</option>
                <option value="30">30 - Aplicación de anticipos</option>
                <option value="31">31 - Intermediario pagos</option>
                <option value="99">99 - Por definir</option>
              </select>
            </div>
          </div>
          <br />
        </div>
      </>
    );
  };
}

export default UpdateTimbraDocs;
